import React, { FC, useState } from 'react';
import { EditorPlatformI18nProvider } from '../providers/EditorPlatformI18nProvider';
import { WixDesignSystemProvider } from '@wix/design-system';
import {
  DeleteAppModalContainer,
  DeleteAppModalProps,
} from './DeleteAppModalContainer/DeleteAppModalContainer';
import { DeleteAppOriginSource } from './DeleteAppModalContainer/constants';

type DeleteAppModalPropsWithTranslations = DeleteAppModalProps & {
  locale: string;
};

export const DeleteAppModal: FC<DeleteAppModalPropsWithTranslations> = ({
  locale,
  ...props
}: DeleteAppModalPropsWithTranslations) => {
  return (
    <WixDesignSystemProvider features={{ newColorsBranding: true }}>
      <EditorPlatformI18nProvider locale={locale}>
        <DeleteAppModalContainer {...props} />
      </EditorPlatformI18nProvider>
    </WixDesignSystemProvider>
  );
};

export { DeleteAppOriginSource };
